module.exports = __webpack_public_path__ + "img/exclamation.aae9c1b3.svg";